<template>
  <el-container style="height: 100%">
    <el-aside width="180px">
      <UserList
        :user-id="userId"
        :user-list="userList"
        @input="handleSelectUser"
      />
    </el-aside>
    <el-main>
      <el-container style="height: 100%">
        <el-aside width="550px">
          <user-detail :user-id="userId" :show-buttons="false" />
        </el-aside>
        <el-main>
          <Chat
            :user-id="userId"
            @changeUserList="handleChangeUserList"
            @userOnline="handleNewUser"
          />
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
  import Chat from '../ui/Chat'
  import UserDetail from "../ui/UserDetail"
  import UserList from './UserList'

  export default {
    name: 'LiOnline',
    components: {
      Chat, UserList, UserDetail
    },
    data: function () {
      return {
        userId: 0,
        userList: []
      }
    },
    methods: {
      handleSelectUser: function (uid) {
        this.userId = uid
      },
      handleChangeUserList: function (userList) {
        this.userList = userList
      },
      handleNewUser: function () {
        new Notification('新用户上线了!')
      }
    }
  }
</script>